export default class EnterpriseInvoiceReturn {
  public id: string;
  public overageDocuments: number;
  public overageSms: number;
  public overageIdentity: number;
  public stripeOveragePrice: number;
  public stripeSmsOveragePrice: number;
  public stripeIdentityOveragePrice: number;
  public total: number;

  constructor(options) {
    this.id = options.id;
    this.overageDocuments = options.overageDocuments;
    this.overageSms = options.overageSms;
    this.overageIdentity = options.overageIdentity;
    this.stripeOveragePrice = options.stripeOveragePrice;
    this.stripeSmsOveragePrice = options.stripeSmsOveragePrice;
    this.stripeIdentityOveragePrice = options.stripeIdentityOveragePrice;
    this.total = options.total;
  }

  url() {
    return `${process.env.VUE_APP_STRIPE_DASHBOARD_BASE}/invoices/${this.id}`;
  }

  totalDocuments() {
    return Math.abs(this.overageDocuments) * this.stripeOveragePrice;
  }

  totalSms() {
    return Math.abs(this.overageSms) * this.stripeSmsOveragePrice;
  }

  totalIdentityRequests() {
    return Math.abs(this.overageIdentity) * this.stripeIdentityOveragePrice;
  }
}
